import { ChangeDetectionStrategy, Component, effect, input, signal, untracked } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'lib-collapsible-content',
  imports: [MatIcon],
  templateUrl: './collapsible-content.component.html',
  styleUrl: './collapsible-content.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollapsibleContentComponent {
  public readonly titleText = input.required<string>();
  public readonly collapseIconPosition = input<CollapsibleContentIconPosition>(CollapsibleContentIconPosition.right);
  public readonly collapsed = input<boolean>(true);
  protected readonly isCollapsed = signal(true);
  protected readonly CollapsibleContentIconPosition = CollapsibleContentIconPosition;

  constructor() {
    effect(() => {
      const collapsed = this.collapsed();
      untracked(() => this.isCollapsed.set(collapsed));
    });
  }

  protected toggleCollapsed() {
    this.isCollapsed.update(value => !value);
  }
}
export enum CollapsibleContentIconPosition {
  left = 'left',
  right = 'right',
}
